import { ImportAccountInvitesPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/account-invites/import'].update({
        staticData: { title: { page: 'ImportInvites.PageHeading' } },
        component: authGuard(ImportAccountInvitesPage, { isWhitelabel: true, canInviteAccounts: true })
    });
};
